(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('LastNameSearch', LastNameSearch);

    LastNameSearch.$inject = ['$resource'];

    function LastNameSearch($resource) {
        var resourceUrl =  'api/_search/last-names/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
